namespace $.$$ {
	export class $shm_hitalama_map_widget_float_ai_request_component extends $.$shm_hitalama_map_widget_float_ai_request_component {
		
		prompt(): string {
			const text = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_prompt.md' ) )
			return text.replace( '{{Описание приложения}}', this.text() )
		}

		sizes() {
			return {
				md_height: 500,
				comp_height: 400,
				app_height: 600,
				css_height: 400,
				gap: 25,
			}
		}

		create_md( descr: string ) {
			const Widget = this.Widget()
			const sizes = this.sizes()

			const md = Widget.map().widget_add( 'text_md', [Widget.left(), Widget.top()+Widget.height()+sizes.gap ], 600, sizes.md_height )
			md?.title( `Ответ ${(new $mol_time_moment).toString('DD.MM.YY hh:mm')}` )
			md?.text( descr )
		}

		create_classes( ts_classes: AI_answer['ts_classes'] ) {
			const Widget = this.Widget()
			const sizes = this.sizes()

			const x = Widget.left()// + Widget.width() + 10
			const y = Widget.top() + Widget.height() + sizes.md_height + sizes.gap*2
			const components_by_name = Widget.map().components_by_name()

			ts_classes?.forEach( (c, i) => {
				const prev_comp = components_by_name[ c.class_name ]
				let comp_data = {
					...c,
					version: 1,
				}

				if( prev_comp ) {
					const new_names = c.methods.map( m => m.name )
					const prev_methods = prev_comp.component().methods() as AI_answer['ts_classes'][number]['methods']
					const methods: AI_answer['ts_classes'][number]['methods'] = [
						...c.methods,
						...prev_methods.filter( 
							(m: AI_answer['ts_classes'][number]['methods'][number]) => !new_names.includes( m.name ) 
						)
					]
					comp_data = {
						...c,
						methods,
						version: prev_comp.component().version() + 1
					}
				}

				const code = create_class( comp_data )
				const widget_y = y + (sizes.comp_height+sizes.gap)*i + sizes.app_height + sizes.css_height + sizes.gap*3
				const widget = Widget.map().widget_add( 'component', [x, widget_y], 600, sizes.comp_height )
				widget?.text( code )
				widget?.title( comp_data.class_name )
				widget?.component().data( comp_data )
			} )
		}

		create_view( obj: AI_answer ) {
			const Widget = this.Widget()
			const sizes = this.sizes()

			const x = Widget.left()// + Widget.width() + 10
			const y = Widget.top() + Widget.height() + sizes.md_height + sizes.gap*2
			
			const components_by_name = Widget.map().components_by_name()
			const class_for_view = obj.ts_classes?.find( c => {

				if( c.type !== 'app' ) return
				const prev_comp = components_by_name[ c.class_name ]
				if( prev_comp ) return
				return true

			} ) ?? obj.ts_classes[0]

			const app_widget = Widget.map().widget_add( 'component_view', [x, y], 600, sizes.app_height )
			app_widget?.text( `const obj = new ${class_for_view.class_name}\nreturn obj` )
			app_widget?.title(`View: ${class_for_view.class_name}`)
			
		}

		parse_css_selectors( obj: AI_answer ) {
			if( !(obj.css_selectors?.length > 0) ) return
				
			const Widget = this.Widget()
			const sizes = this.sizes()

			const x = Widget.left()// + Widget.width() + 10
			const y = Widget.top() + Widget.height() + sizes.md_height + sizes.gap*2

			const css_widget = Widget.map().component_css()!
			if( !css_widget ) {
				const css_widget = Widget.map().widget_add( 'code_css', [x, y + sizes.app_height + sizes.gap ], 600, sizes.css_height )
				css_widget?.title(`CSS for components`)

				css_widget?.component().css_selectors( obj.css_selectors )
				css_widget?.text( create_css( obj.css_selectors ) )
				return
			}

			const new_selectors = obj.css_selectors.map( s => s.selector )

			const css_selectors = css_widget.component().css_selectors() as AI_answer['css_selectors']
			const next_css_selectors: AI_answer['css_selectors'] = [
				...obj.css_selectors,
				...css_selectors.filter( 
					(m: AI_answer['css_selectors'][number]) => !new_selectors.includes( m.selector ) 
				)
			]

			css_widget.component().css_selectors( next_css_selectors )
			css_widget?.text( create_css( next_css_selectors ) )
		}

		paste() {
			const text = $mol_wire_sync(navigator.clipboard).readText()
			const obj = JSON.parse( text ) as AI_answer

			return $shm_hitalama_map_history.transaction( this.Widget().map(), 'Создание виджетов из ответа', ()=> {
				this.create_md( obj.md_description )
				this.create_view( obj )
				this.parse_css_selectors( obj )
				this.create_classes( obj.ts_classes )
			} )
		}
		
	}

	export type $shm_hitalama_map_widget_float_ai_request_component_answer = {
		ts_classes: {
			class_name: string,
			extends: string,
			type: 'app' | 'view' | 'model',
			methods: {
				name: string,
				params: '' | string,
				decorator: '' | '$mol_mem' | '$mol_mem_key',
				body: string,
			}[],
		}[],
		css_selectors: {
			selector: string,
			body: string,
		}[],
		md_description: string,
	}
	type AI_answer = $shm_hitalama_map_widget_float_ai_request_component_answer
	
	function create_class( obj: AI_answer['ts_classes'][number] ): string {
		const { class_name, extends: extendsClass, methods } = obj;
		
		const methodsCode = methods.map(method => {
			const { name, params, decorator, body } = method;
			
			const formattedBody = body
				.split('\n')
				.map(line => `        ${line}`)
				.join('\n');
			
			let methodCode = '';
			if (decorator) {
				methodCode += `    @ ${decorator}\n`;
			}
			methodCode += `    ${name}(${params || ''}) {\n`;
			methodCode += `${formattedBody}\n`;
			methodCode += `    }`;
			
			return methodCode;
		}).join('\n\n');
		
		// Формируем объявление наследования
		const extendsDeclaration = extendsClass ? ` extends ${extendsClass}` : '';
		
		// Собираем полный код класса
		return `class ${class_name}${extendsDeclaration} {\n${methodsCode}\n}`;
	}

	function create_css( css_selectors: AI_answer[ 'css_selectors' ] ): string {
		if( !css_selectors || css_selectors.length === 0 ) {
			return ''
		}
		const cssRules: string[] = []
		for( const rule of css_selectors ) {
			if( rule.selector && rule.body ) {
				cssRules.push( `${ rule.selector.trim() } { ${ rule.body.trim() } }` )
			}
		}
		return cssRules.join( '\n' )
	}

}
